"use client";

import { PAASection } from "@/components/sections/paa";
import { paa } from "@/lib/data/services-competitive-intelligence";

export function PAA() {
  return (
    <PAASection
      eyebrow={paa.eyebrow}
      title={paa.title}
      accent={paa.accent}
      items={paa.items}
    />
  );
}